<div class="container single-view" id="survey-selector">
  <div class="row">
    <div class="col-12 mb-6 flex flex-wrap items-end justify-between gap-4">
      <div id="pre-header-wr">
        <a data-testid="back-btn" appBack [fallbackUrl]="'/surveys/'"
        class="inline-flex items-center text-base link link-icon left-arrow">{{ 'SURVEYS.BTN_BACK_TO_SURVEYS' | translate }}</a>
      </div>
    </div>

    <div class="col-12">
      <div id="view-header-wr" class="flex flex-wrap items-end justify-between gap-4">
        <div class="title-wr">
          <h1 data-testid="survey-selector-title" class="section-title">{{ 'SURVEY_SELECTOR.TITLE' | translate }}</h1>
        </div>
      </div>

      <hr role="presentation" class="w-full mb-3 mt-6 border-t">

      <div class="view-content-wr">
        <div class="row">
          <div class="flex flex-col col-12 mb-2 text-wr">
            <!-- main content -->
            <section class="row">
              <div class="col-12">
                <form [formGroup]="surveyFormGroup">
                  <p class="text-center text-sm mt-4 mb-4">{{ 'SURVEY_SELECTOR.HELPER_TEXT' | translate }}</p>
                  @if (hasLoadedSurveys) {
                    <app-custom-dropdown
                      data-testid="surveys-dropdown"
                      class="surveys-dropdown"
                      [compactUi]="false"
                      [placeholder]="'SURVEY_SELECTOR.SELECT_SURVEY' | translate"
                      [options]="surveys"
                      optionLabel="text"
                      optionValue="id"
                      [isMultiselect]="false"
                      [showSelectionChips]="true"
                      [showClear]="false"
                      [showSearchbox]="true"
                      [searchMode]="'remote'"
                      [pageSize]="surveyRowsPerPageOption"
                      [totalCount]="surveyTotalCount"
                      [totalPages]="surveyTotalPages"
                      formControlName="_survey"
                      (onLazyLoad)="onLazyLoadSurveys($event)">
                    </app-custom-dropdown>
                  } @else {
                    <p class="empty-surveys-message">
                      {{ 'SURVEY_SELECTOR.NO_SURVEYS_AVAILABLE' | translate }}
                    </p>
                  }

                </form>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
